import { usePromotion } from '#lib/composables'
import { usePromotionStore } from '#lib/stores'

/**
 * Composable for managing the state and actions related to canceling promotions.
 *
 * @returns {Object} An object containing reactive variables and methods for handling promotion cancellation.
 * @namespace
 */
export const useCancelPromotion = () => {
  // Access the `onCancelPromotion` function from the `usePromotion` composable.
  const { onCancelPromotion } = usePromotion()

  const { setOpenCancelPromotionModal, setOpenConfirmCancelPromotionModal } =
    usePromotionStore()

  /**
   * Opens the modal for canceling the promotion and closes the confirm cancel promotion modal.
   */
  const openModalCancelPromotion = () => {
    setOpenCancelPromotionModal(true)
    setOpenConfirmCancelPromotionModal(false)
  }

  /**
   * Opens the confirm cancel promotion modal and closes the cancel promotion modal.
   */
  const openModalConfirmCancelPromotion = () => {
    setOpenConfirmCancelPromotionModal(true)
    setOpenCancelPromotionModal(false)
  }

  return {
    onCancelPromotion,
    openModalCancelPromotion,
    openModalConfirmCancelPromotion,
  }
}
